<div class="wrapper" *ngIf="currentUser">
    <app-header></app-header>
    <app-sidebar></app-sidebar>
    <app-copyright></app-copyright>
</div>


<div [ngClass]="{main: currentUser}" *ngIf="!currentUser">
    <alert></alert>
    <router-outlet></router-outlet>
</div>
